import MenuConfig from "../../../constants/MenuConfig";
import Module from "../../../constants/Module";

export const MenuList = [

    // Dashboard
    // Sem o module, o SideBar libera o bloco para qualquer usuário (ver "if
    // (!menuItem.module) return true"), e a Visão do Negócio expõe faturamento,
    // contas a pagar/receber e ranking de colaboradores para toda a equipe.
    {
        module: Module.DASHBOARD,
        title: MenuConfig.dashboard.title,
        classsChange: 'mm-collapse',
        iconStyle: "bi bi-grid",
        content: [
            {
                title: 'Visão do Negócio',
                to: 'dashboard',
                exact: true,
                menuKey: "business_overview",
            },
            {
                title: MenuConfig.dashboard.birthdays.title,
                to: MenuConfig.dashboard.birthdays.route,
                menuKey: "birthdays",
            },
            {
                title: MenuConfig.dashboard.customer.nonReturning.title,
                to: MenuConfig.dashboard.customer.nonReturning.route,
                menuKey: "non_returning_customers",
            },

            /*
            {
                title: 'Dashboard Dark',
                to: 'dashboard-dark',
                
            },
            {
                title: 'Food Order',
                to: 'food-order',
                
            },
            {
                title: 'Favorite Menu',
                to: 'favorite-menu',
                

            },
            {
                title: 'Message',
                to: 'message',
                
            },
            {
                title: 'Order History',
                to: 'order-history',
                
            },
            {
                title: 'Notification',
                to: 'notification',
                
            },
            {
                title: 'Bill',
                to: 'bill',
                
            },
            {
                title: 'Setting',
                to: 'setting',
                
            },*/

        ],
    },

    // Central de Relatórios
    // Bloco com um item só de propósito: o hub é a porta única dos relatórios e
    // os novos relatórios entram como cartão na tela, não como item de menu.
    {
        module: Module.REPORTS,
        title: MenuConfig.reports.title,
        classsChange: 'mm-collapse',
        iconStyle: "fa-solid fa-chart-pie",
        content: [
            {
                title: MenuConfig.reports.hub.title,
                to: MenuConfig.reports.hub.route,
                exact: true,
                menuKey: "hub",
            },
            {
                title: MenuConfig.reports.employee_statement.title,
                to: MenuConfig.reports.employee_statement.route,
                menuKey: "employee_statement",
            }
            ,{
                title: MenuConfig.reports.financial_summary.title,
                to: MenuConfig.reports.financial_summary.route,
                menuKey: "financial_summary",
            }
            ,{
                title: MenuConfig.reports.pot.title,
                to: MenuConfig.reports.pot.route,
                menuKey: "pot",
            }
            ,{
                title: MenuConfig.reports.extra_services.title,
                to: MenuConfig.reports.extra_services.route,
                menuKey: "extra_services",
            }
        ]
    },

    // Main
    {
        module: Module.REGISTRATION,
        title: MenuConfig.main.title,
        classsChange: 'mm-collapse',
        iconStyle: "bi bi-box",
        content: [
            {
                title: MenuConfig.main.branch.title,
                to: MenuConfig.main.branch.route,
                menuKey: "branch",
            },
            {
                title: MenuConfig.main.card_flag.title,
                to: MenuConfig.main.card_flag.route,
                menuKey: "card_flag",
            },
            {
                title: MenuConfig.main.category.title,
                to: MenuConfig.main.category.route,
                menuKey: "category",
            },
            {
                title: MenuConfig.main.customer.title,
                to: MenuConfig.main.customer.route,
                menuKey: "customer",
            },
            {
                title: MenuConfig.main.employee.title,
                to: MenuConfig.main.employee.route,
                menuKey: "employee",
            },
            {
                title: MenuConfig.main.vendor.title,
                to: MenuConfig.main.vendor.route,
                menuKey: "vendor",
            },
            {
                title: MenuConfig.main.product.title,
                to: MenuConfig.main.product.route,
                menuKey: "product",
            },
            {
                title: MenuConfig.main.service.title,
                to: MenuConfig.main.service.route,
                menuKey: "service",
            }
        ]
    },

    // Agendamentos
    {
        module: Module.APPOINTMENT,
        title: MenuConfig.appointment.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-light fa-calendar-days',
        content: [
            {
                title: MenuConfig.appointment.dashboard.title,
                to: MenuConfig.appointment.dashboard.route,
                menuKey: "dashboard",
            },
            /*
             * Oculta "Lançamentos" para direcionar a recepção ao fluxo operacional
             * da Agenda. A rota permanece cadastrada para não quebrar links internos
             * e permitir reativação futura sem remover a funcionalidade.
             */
            // {
            //     title: MenuConfig.appointment.appointment.title,
            //     to: MenuConfig.appointment.appointment.route,
            //     menuKey: "appointment",
            // },
            {
                title: MenuConfig.appointment.review.title,
                to: MenuConfig.appointment.review.route,
                menuKey: "review",
            },
            {
                title: MenuConfig.appointment.block.title,
                to: MenuConfig.appointment.block.route,
                menuKey: "block",
            },
            // Mesma permissão de Bloqueios de agenda: as duas telas fecham a agenda, e uma chave
            // nova ficaria travada em todos os planos até ser liberada um a um.
            {
                title: MenuConfig.appointment.special_day.title,
                to: MenuConfig.appointment.special_day.route,
                menuKey: "block",
            },
            // Também sob a permissão de Bloqueios: liberar cliente penalizado é a mesma decisão
            // de abrir ou fechar a agenda para alguém.
            {
                title: MenuConfig.appointment.blocked_customer.title,
                to: MenuConfig.appointment.blocked_customer.route,
                menuKey: "block",
            }
        ]
    },

    // Vendas
    {
        module: Module.SALES,
        title: MenuConfig.sales.title,
        classsChange: 'mm-collapse',
        iconStyle: "fa-light fa-cash-register",
        content: [
            {
                title: MenuConfig.sales.order.title,
                to: MenuConfig.sales.order.route,
                menuKey: "order",
            },
            {
                title: MenuConfig.sales.commission_rule.title,
                to: MenuConfig.sales.commission_rule.route,
                menuKey: "commission_rule",
            },
            {
                title: MenuConfig.sales.reason.title,
                to: MenuConfig.sales.reason.route,
                menuKey: "reason",
            }
        ]
    },

// Fluxo de Caixa
    {
        module: Module.CASH_FLOW,
        title: MenuConfig.cash_flow.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-light fa-piggy-bank',
        content: [
            {
                title: MenuConfig.cash_flow.cash_registers.title,
                to: MenuConfig.cash_flow.cash_registers.route,
                menuKey: "cash_registers",
            },
            {
                title: MenuConfig.cash_flow.transaction.title,
                to: MenuConfig.cash_flow.transaction.route,
                menuKey: "transaction",
            },
            {
                title: MenuConfig.cash_flow.payable_receivable.title,
                to: MenuConfig.cash_flow.payable_receivable.route,
                menuKey: "payable_receivable",
            },
            {
                title: MenuConfig.cash_flow.categories.title,
                to: MenuConfig.cash_flow.categories.route,
                menuKey: "categories",
            },
            {
                title: MenuConfig.cash_flow.advance.title,
                to: MenuConfig.cash_flow.advance.route,
                menuKey: "advance",
            },
            {
                title: MenuConfig.cash_flow.employee_consumption.title,
                to: MenuConfig.cash_flow.employee_consumption.route,
                menuKey: "employee_consumption",
            },
            {
                title: MenuConfig.cash_flow.employee_bonus.title,
                to: MenuConfig.cash_flow.employee_bonus.route,
                menuKey: "employee_bonus",
            },
            {
                title: MenuConfig.cash_flow.employee_payment.title,
                to: MenuConfig.cash_flow.employee_payment.route,
                menuKey: "employee_payment",
            },
            {
                title: MenuConfig.cash_flow.dre_report.title,
                to: MenuConfig.cash_flow.dre_report.route,
                menuKey: "dre_report",
            }
            // Importar Dados fica fora do menu. A rota, a tela e a permissão continuam de pé,
            // então basta devolver este item aqui para o acesso voltar.
        ]
    },

    // Performance
    {
        module: Module.PERFORMANCE,
        title: MenuConfig.performance.title,
        classsChange: 'mm-collapse',
        iconStyle: "fa-light fa-chart-line",
        content: [
            {
                title: MenuConfig.performance.dashboard.title,
                to: MenuConfig.performance.dashboard.route,
                menuKey: "dashboard",
            },
            {
                title: MenuConfig.performance.reports.title,
                to: MenuConfig.performance.reports.route,
                // Compartilha o acesso ao painel: planos e grupos existentes não têm
                // uma chave nova para este submenu e devem manter acesso aos relatórios.
                menuKey: "dashboard",
            },
            {
                title: MenuConfig.performance.plan.title,
                to: MenuConfig.performance.plan.route,
                menuKey: "plan",
            },
            {
                title: MenuConfig.performance.employee_plan.title,
                to: MenuConfig.performance.employee_plan.route,
                menuKey: "employee_plan",
            }
        ]
    },

    // Assinaturas
    {
        module: Module.SUBSCRIPTION,
        title: MenuConfig.subscription.title,
        classsChange: 'mm-collapse',
        iconStyle: "fa-solid fa-arrows-rotate",
        content: [
            {
                title: MenuConfig.subscription.dashboard.title,
                to: MenuConfig.subscription.dashboard.route,
                menuKey: "dashboard",
            },
            {
                title: MenuConfig.subscription.plan.title,
                to: MenuConfig.subscription.plan.route,
                menuKey: "plan",
            },
            {
                title: MenuConfig.subscription.subscription.title,
                to: MenuConfig.subscription.subscription.route,
                menuKey: "subscription",
            },
            {
                title: MenuConfig.subscription.charge.title,
                to: MenuConfig.subscription.charge.route,
                menuKey: "charge",
            },
            {
                title: MenuConfig.subscription.club_partner.title,
                to: MenuConfig.subscription.club_partner.route,
                menuKey: "club_partner",
            }
        ]
    },

    // Gamificação
    {
        module: Module.GAMIFICATION,
        title: MenuConfig.gamification.title,
        classsChange: 'mm-collapse',
        iconStyle: "fa-solid fa-coins",
        content: [
            {
                title: MenuConfig.gamification.score.title,
                to: MenuConfig.gamification.score.route,
                menuKey: "score",
            },
            {
                title: MenuConfig.gamification.pot.title,
                to: MenuConfig.gamification.pot.route,
                menuKey: "pot",
            },
            {
                title: MenuConfig.gamification.pot_bonus_rule.title,
                to: MenuConfig.gamification.pot_bonus_rule.route,
                menuKey: "pot_bonus_rule",
            }
        ]
    },

    // WhatsApp com IA
    {
        module: Module.WHATSAPP,
        title: MenuConfig.chat_bot.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fab fa-whatsapp',
        content: [
            {
                title: MenuConfig.chat_bot.dashboard.title,
                to: MenuConfig.chat_bot.dashboard.route,
                menuKey: "dashboard",
            },
            {
                title: MenuConfig.chat_bot.bot.title,
                to: MenuConfig.chat_bot.bot.route,
                menuKey: "bot",
            },
            {
                title: MenuConfig.chat_bot.conversation.title,
                to: MenuConfig.chat_bot.conversation.route,
                menuKey: "conversation",
            },
            {
                title: MenuConfig.chat_bot.settings.title,
                to: MenuConfig.chat_bot.settings.route,
                menuKey: "settings",
            },
        ]
    },

    // Controle de Estoque
    // Estoque
    {
        module: Module.STOCK_CONTROL,
        title: MenuConfig.stock_control.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-light fa-boxes-stacked',
        content: [
            {
                title: MenuConfig.stock_control.stock.title,
                to: MenuConfig.stock_control.stock.route,
                menuKey: "stock",
            },
            {
                title: MenuConfig.stock_control.restock.title,
                to: MenuConfig.stock_control.restock.route,
                menuKey: "restock",
            },
        ]
    },

// Entregadores / Motoristas
    /*{
        title: 'Drivers',
        classsChange: 'mm-collapse',
        iconStyle: "bi bi-bicycle",
        content: [
            {
                title:'Dashboard',
                to: 'deliver-main'
            },
            {
                title:'Orders',
                to: 'deliver-order'
            },
            {
                title:'Feedback',
                to: 'feedback'
            },
        ],
    },*/

// Adiciona um item extra se o usuário for admin
    {
        title: MenuConfig.identity.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-regular fa-users',
        content: [
            {
                title: MenuConfig.identity.user.title,
                to: MenuConfig.identity.user.route,
            },
            {
                title: MenuConfig.identity.group.title,
                to: MenuConfig.identity.group.route,
            }
        ],
        adminOnly: true, 
    },

    // Central de Ajuda
    // Item único e sem module de propósito: material de treinamento do produto precisa
    // alcançar também o operador que só tem acesso ao balcão.
    //
    // O rótulo é "Ajuda", e não o formato do conteúdo: é a palavra que o operador procura
    // quando está perdido, e assim outros tipos de ajuda (FAQ, contato) cabem na mesma
    // porta sem precisar renomear o menu.
    //
    // Fica depois dos módulos de trabalho e ANTES de Plataforma: os blocos seguintes são de
    // superadmin e não aparecem para a barbearia, então na tela dela a Ajuda é o último item.
    {
        title: MenuConfig.help.title,
        iconStyle: "fa-regular fa-circle-question",
        to: MenuConfig.help.tutorials.route,
    },

    // Super Admin Only
    {
        title: MenuConfig.superadmin.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-solid fa-user-shield',
        superAdminOnly: true,
        content: [
            {
                title: MenuConfig.superadmin.company.title,
                to: 'superadmin/company',
            },
            {
                title: MenuConfig.superadmin.company_api.title,
                to: 'superadmin/company-apis',
            },
            {
                title: MenuConfig.superadmin.whatsapp.title,
                to: MenuConfig.superadmin.whatsapp.route,
            },
            {
                title: MenuConfig.superadmin.announcement.title,
                to: MenuConfig.superadmin.announcement.route,
            },
            {
                title: MenuConfig.integration.payment_provider.title,
                to: MenuConfig.integration.payment_provider.route,
            },
        ],
    },

    // Cobrança SaaS é um módulo próprio da plataforma, separado da administração.
    {
        title: MenuConfig.superadmin.saas_billing.title,
        classsChange: 'mm-collapse',
        iconStyle: 'fa-solid fa-file-invoice-dollar',
        superAdminOnly: true,
        content: [
            { title: 'Planos', to: MenuConfig.superadmin.saas_billing.plansRoute },
            { title: 'Contratos', to: MenuConfig.superadmin.saas_billing.contractsRoute },
            { title: 'Webhooks', to: MenuConfig.superadmin.saas_billing.webhooksRoute },
        ],
    },
    
    
    // {
    //     title: 'Other',
    //     classsChange: 'menu-title'
    // },


    //Apps
    // {
    //     title: 'Apps',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-info-circle",
    //     content: [
    //         {
    //             title: 'Profile',
    //             to: 'app-profile'
    //         },
    //         {
    //             title: 'Post Details',
    //             to: 'post-details'
    //         },
    //         {
    //             title: 'Email',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Compose',
    //                     to: 'email-compose',
    //                 },
    //                 {
    //                     title: 'Index',
    //                     to: 'email-inbox',
    //                 },
    //                 {
    //                     title: 'Read',
    //                     to: 'email-read',
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Calendar',
    //             to: 'app-calender'
    //         },
    //         {
    //             title: 'Shop',
    //             //to: './',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Product Grid',
    //                     to: 'ecom-product-grid',
    //                 },
    //                 {
    //                     title: 'Product List',
    //                     to: 'ecom-product-list',
    //                 },
    //                 {
    //                     title: 'Product Details',
    //                     to: 'ecom-product-detail',
    //                 },
    //                 {
    //                     title: 'Order',
    //                     to: 'ecom-product-order',
    //                 },
    //                 {
    //                     title: 'Checkout',
    //                     to: 'ecom-checkout',
    //                 },
    //                 {
    //                     title: 'Invoice',
    //                     to: 'ecom-invoice',
    //                 },
    //                 {
    //                     title: 'Customers',
    //                     to: 'ecom-customers',
    //                 },
    //             ],
    //         },
    //     ],
    // },
    // //Charts
    // {
    //     title: 'Charts',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-pie-chart",
    //     content: [

    //         {
    //             title: 'RechartJs',
    //             to: 'chart-rechart',
    //         },
    //         {
    //             title: 'Chartjs',
    //             to: 'chart-chartjs',
    //         },
    //         {
    //             title: 'Sparkline',
    //             to: 'chart-sparkline',
    //         },
    //         {
    //             title: 'Apexchart',
    //             to: 'chart-apexchart',
    //         },
    //     ]
    // },
    // //Boosttrap
    // {
    //     title: 'Bootstrap',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-star",
    //     content: [
    //         {
    //             title: 'Accordion',
    //             to: 'ui-accordion',
    //         },
    //         {
    //             title: 'Alert',
    //             to: 'ui-alert',
    //         },
    //         {
    //             title: 'Badge',
    //             to: 'ui-badge',
    //         },
    //         {
    //             title: 'Button',
    //             to: 'ui-button',
    //         },
    //         {
    //             title: 'Modal',
    //             to: 'ui-modal',
    //         },
    //         {
    //             title: 'Button Group',
    //             to: 'ui-button-group',
    //         },
    //         {
    //             title: 'List Group',
    //             to: 'ui-list-group',
    //         },
    //         {
    //             title: 'Cards',
    //             to: 'ui-card',
    //         },
    //         {
    //             title: 'Carousel',
    //             to: 'ui-carousel',
    //         },
    //         {
    //             title: 'Dropdown',
    //             to: 'ui-dropdown',
    //         },
    //         {
    //             title: 'Popover',
    //             to: 'ui-popover',
    //         },
    //         {
    //             title: 'Progressbar',
    //             to: 'ui-progressbar',
    //         },
    //         {
    //             title: 'Tab',
    //             to: 'ui-tab',
    //         },
    //         {
    //             title: 'Typography',
    //             to: 'ui-typography',
    //         },
    //         {
    //             title: 'Pagination',
    //             to: 'ui-pagination',
    //         },
    //         {
    //             title: 'Grid',
    //             to: 'ui-grid',
    //         },
    //     ]
    // },
    // //plugins
    // {
    //     title: 'Plugins',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-heart",
    //     content: [
    //         {
    //             title: 'Select 2',
    //             to: 'uc-select2',
    //         },

    //         {
    //             title: 'Sweet Alert',
    //             to: 'uc-sweetalert',
    //         },
    //         {
    //             title: 'Toastr',
    //             to: 'uc-toastr',
    //         },
    //         {
    //             title: 'Jqv Map',
    //             to: 'map-jqvmap',
    //         },
    //         {
    //             title: 'Light Gallery',
    //             to: 'uc-lightgallery',
    //         },
    //     ]
    // },
    // //Widget
    // {
    //     title: 'Widget',
    //     //classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-gear-wide",
    //     to: 'widget-basic',
    // },
    // //Forms
    // {
    //     title: 'Forms',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-file-earmark-check",
    //     content: [
    //         {
    //             title: 'Form Elements',
    //             to: 'form-element',
    //         },
    //         {
    //             title: 'Wizard',
    //             to: 'form-wizard',
    //         },
    //         {
    //             title: 'CkEditor',
    //             to: 'form-ckeditor',
    //         },
    //         {
    //             title: 'Pickers',
    //             to: 'form-pickers',
    //         },
    //         {
    //             title: 'Form Validate',
    //             to: 'form-validation',
    //         },

    //     ]
    // },
    // //Table
    // {
    //     title: 'Table',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-file-earmark-spreadsheet",
    //     content: [
    //         {
    //             title: 'Table Filtering',
    //             to: 'table-filtering',
    //         },
    //         {
    //             title: 'Table Sorting',
    //             to: 'table-sorting',
    //         },
    //         {
    //             title: 'Bootstrap',
    //             to: 'table-bootstrap-basic',
    //         },


    //     ]
    // },
    // //Pages
    // {
    //     title: 'Pages',
    //     classsChange: 'mm-collapse',
    //     iconStyle: "bi bi-file-earmark-break",
    //     content: [
    //         {
    //             title: 'Error',
    //             hasMenu: true,
    //             content: [
    //                 {
    //                     title: 'Error 400',
    //                     to: 'page-error-400',
    //                 },
    //                 {
    //                     title: 'Error 403',
    //                     to: 'page-error-403',
    //                 },
    //                 {
    //                     title: 'Error 404',
    //                     to: 'page-error-404',
    //                 },
    //                 {
    //                     title: 'Error 500',
    //                     to: 'page-error-500',
    //                 },
    //                 {
    //                     title: 'Error 503',
    //                     to: 'page-error-503',
    //                 },
    //             ],
    //         },
    //         {
    //             title: 'Lock Screen',
    //             to: 'page-lock-screen',
    //         },

    //     ]
    // },

]
